
export const DEFAULT_PAGE_CONTEXT = {
  isPublicPage: false,
  isOffersPage: false,
  isFeedPage: false,
}
